// One owner covers the entire operation, including a retry's initial GET.
// Invalidation fences continuations that finish after this page has left.
export function createPublicRoomMutationScope(
  pending: (roomId: string) => void,
) {
  let active: object | undefined;
  return {
    async run(
      roomId: string,
      operation: (isCurrent: () => boolean) => Promise<void>,
    ) {
      if (active) return false;
      const identity = {};
      active = identity;
      pending(roomId);
      try {
        await operation(() => active === identity);
        return true;
      } finally {
        if (active === identity) {
          active = undefined;
          pending('');
        }
      }
    },
    invalidate() {
      active = undefined;
    },
  };
}
